__turbopack_context__.v({
  "bgImageContainer": "ClientRelationshipsSection-module-scss-module__XHINNW__bgImageContainer",
  "bgImageContainerMobile": "ClientRelationshipsSection-module-scss-module__XHINNW__bgImageContainerMobile",
  "blur": "ClientRelationshipsSection-module-scss-module__XHINNW__blur",
  "container": "ClientRelationshipsSection-module-scss-module__XHINNW__container",
  "content": "ClientRelationshipsSection-module-scss-module__XHINNW__content",
  "title": "ClientRelationshipsSection-module-scss-module__XHINNW__title",
});
